// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__mwQZW","inputDescription":"styles_inputDescription__1k6XQ"};